import { ErrorMessage } from '@hookform/error-message';
import { Typography } from '@mui/material';
import * as React from 'react';
import { FieldErrors } from 'react-hook-form';

import { useSxStyles } from './useStyles';

export interface WithFormErrors {
  form?: unknown;
}

export interface Props {
  errors: FieldErrors<WithFormErrors>;
  dataCy?: string;
}

export const FormError: React.FC<Props> = ({ errors, dataCy }) => {
  const sxStyles = useSxStyles();

  if (!errors.form) {
    return null;
  }

  return (
    <Typography color="error" sx={sxStyles.root} data-cy={dataCy}>
      <ErrorMessage errors={errors} name="form" />
    </Typography>
  );
};
